module.exports = __webpack_public_path__ + "static/media/bkg50d.5c35f29a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg50d.jpg
// module id = 479
// module chunks = 0